module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-bul-3a9971b6b80a3fe1ceec3aa73f676af5.png";